import { PieChartPresetHandler } from '@src/slide/domain/ui-model/element-modeles/chart-models/chart-presets/sub-chart-presets/pie';
import type { PresetChartType } from '@src/slide/domain/ui-model/element-modeles/chart-models/chart-presets/const';
import type { SeriesInitialProps } from '@src/slide/domain/ui-model/element-modeles/chart-models/chart-presets/sub-chart-presets/base';
import { DoughnutChart } from '../../sub-chart/doughnut-chart';
import { IDoughnutChart } from '../../../Interface/chart-v3/sub-chart';
import { PieChartSeries } from '@src/slide/domain/ui-model/element-modeles/chart-models/sub-chart/series-v2/pie-chart-series';
import { IChartSpace } from '../../../Interface/chart-v3/chart-properties.interface';

export class DoughnutChartPresetHandler extends PieChartPresetHandler {
    get ChartSeries() {
        return PieChartSeries;
    }
    get SubChart() {
        return DoughnutChart;
    }

    public createChartModel(
        type: PresetChartType,
        chartSpace: IChartSpace,
        initialProps?: SeriesInitialProps,
    ): IDoughnutChart {
        const subChart = super.createChartModel(type, chartSpace, initialProps) as IDoughnutChart;

        subChart.holeSize = 75;

        return subChart;
    }
}
